import { db } from '../firebase';
import { doc, setDoc, serverTimestamp, increment } from 'firebase/firestore';

export async function incrementDocUsage(uid, key, title, kind = 'document') {
  try {
    if (!uid || !key) return;
    const ref = doc(db, 'users', uid, 'stats', 'docUsage', key);
    await setDoc(ref, {
      key,
      title: title || key,
      kind,
      count: increment(1),
      lastOpenedAt: serverTimestamp(),
    }, { merge: true });
  } catch (e) {
    // Non-blocking: just log
    console.warn('incrementDocUsage failed:', e);
  }
}